import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useToast, useModal, usePage } from "@/comn/hooks";
import { APIS, URLS, SF_APRV_PRCSS_PATH_MGMT_SRCH, SG_APRV_PRCSS_PATH_MGMT_LIST } from "./services/PtliAprvPathService";

/*
 *  Approval Path Management List
 * !== 결재선 관리 목록 ==!
 */
export const PTLI0409001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0033", "auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Approval Path Management List Search !== 결재선 관리 목록 검색 ==!
        aprvPathMgmtList: useForm({
            defaultSchema: SF_APRV_PRCSS_PATH_MGMT_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Approval Path Management List !== 결재선 관리 목록 ==!
        aprvPathMgmtList: useGrid({
            defaultSchema: SG_APRV_PRCSS_PATH_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //Check Approval Path Management List !== 결재선 관리 목록 조회==!
        getAprvPathMgmtList: useFetch({
            api: (page = grid.aprvPathMgmtList.page) =>
                APIS.getAprvPathMgmtList(form.aprvPathMgmtList.getValues(), page, grid.aprvPathMgmtList.size),
            enabled: comnUtils.isEmpty(form.aprvPathMgmtList.errors),
            key: [grid.aprvPathMgmtList.page, grid.aprvPathMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.aprvPathMgmtList.getValues(),
                    page: grid.aprvPathMgmtList.page,
                    size: grid.aprvPathMgmtList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    // Move Modification Screen !== 그리드 클릭시 수정 화면으로 이동 ==!
    const render = {
        cell: {
            aprvPrcssPathMgmtId: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ptli0409003s}/${rowValues.aprvPrcssPathMgmtId}`}>{value}</Link>;
            },
        },
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        onSrchBtnClick: () => {
            grid.aprvPathMgmtList.setPage(0);
            fetch.getAprvPathMgmtList.fetch(0);
        },
        // Click Registration Button  !== 등록 버튼 클릭 ==!
        onNewBtnClick: () => {
            navigate(`${URLS.ptli0409002s}?menuId=${menuId}`);
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.onSrchBtnClick();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Row>
                        <Group.Control {...form.aprvPathMgmtList.schema.aprvPrcssPathNm} />
                    </Group.Row>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.aprvPathMgmtList.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.aprvPathMgmtList.grid}
                            data={fetch.getAprvPathMgmtList.data?.aprvPathMgmtList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"new"} onClick={handler.onNewBtnClick} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
